import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SeatCategory } from '@digilize/shared/definitions/src';

@Injectable({ providedIn: 'root' })
export class SeatCategoriesApiService {
  private readonly baseUrl = '/api/v1.0/seats/categories';

  constructor(private http: HttpClient) {}

  getCategories(params: { company: string }) {
    return this.http.get<SeatCategory[]>(this.baseUrl, { params });
  }

  getCategory(id: string) {
    return this.http.get<SeatCategory>(`${this.baseUrl}/${id}`);
  }

  addCategory(body: { company_id: string; name: string; color: string; weight: number }) {
    return this.http.post<SeatCategory>(this.baseUrl, body);
  }

  updateCategory(body: { id: string; name: string; color: string; weight: number }) {
    return this.http.put<SeatCategory>(this.baseUrl, body);
  }

  deleteCategory(id: string) {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
